import { motion } from "framer-motion";
import React from "react";

export default function SearchBar({ onClick, display, onInput, width }) {
  return (
    <>
      <div className="flex gap-[4px] search-bar h-[52px]">
        <div className="flex w-full">
          <div className="bg-white flex items-center justify-center pl-4 pr-[8px] h-[52px] rounded-s-md">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5002 17.4999L13.881 13.8808M13.881 13.8808C14.5001 13.2617 14.9912 12.5267 15.3262 11.7179C15.6612 10.909 15.8337 10.0421 15.8337 9.16659C15.8337 8.29109 15.6612 7.42416 15.3262 6.61531C14.9912 5.80645 14.5001 5.0715 13.881 4.45243C13.2619 3.83335 12.527 3.34228 11.7181 3.00724C10.9093 2.6722 10.0423 2.49976 9.16684 2.49976C8.29134 2.49976 7.42441 2.6722 6.61555 3.00724C5.80669 3.34228 5.07174 3.83335 4.45267 4.45243C3.2024 5.7027 2.5 7.39844 2.5 9.16659C2.5 10.9347 3.2024 12.6305 4.45267 13.8808C5.70295 15.131 7.39868 15.8334 9.16684 15.8334C10.935 15.8334 12.6307 15.131 13.881 13.8808Z"
                stroke="gray"
                strokeOpacity="0.5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <label htmlFor="search" className="sr-only">
            Rechercher une pizza
          </label>
          <input
            type="text"
            placeholder="Rechercher une pizza"
            className="bg-white w-full text-base-100 rounded-e-md"
            onChange={onInput}
            aria-labelledby="search"
          />
        </div>
        <motion.button
          whileHover={{
            scale: 1.05,
          }}
          transition={{
            duration: 0.5,
            ease: "backInOut",
          }}
          className={
            display === "mosaic"
              ? "bg-primary w-[52px] flex items-center justify-center"
              : "bg-white text-base-100 w-[52px] flex items-center justify-center"
          }
          onClick={onClick}
          name="mosaic"
          aria-label="Affichage des pizzas en mosaïque"
        >
          <svg
            style={{ pointerEvents: "none" }}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_677_5609)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0969 17.3001C12.7864 17.3001 13.4478 17.574 13.9354 18.0616C14.423 18.5492 14.6969 19.2105 14.6969 19.9001V25.1001C14.6969 25.7896 14.423 26.4509 13.9354 26.9385C13.4478 27.4261 12.7864 27.7001 12.0969 27.7001H6.89688C6.20731 27.7001 5.54599 27.4261 5.0584 26.9385C4.5708 26.4509 4.29688 25.7896 4.29688 25.1001V19.9001C4.29688 19.2105 4.5708 18.5492 5.0584 18.0616C5.54599 17.574 6.20731 17.3001 6.89688 17.3001H12.0969ZM25.0969 17.3001C25.7528 17.2998 26.3846 17.5476 26.8656 17.9936C27.3466 18.4396 27.6412 19.051 27.6904 19.7051L27.6969 19.9001V25.1001C27.6971 25.756 27.4494 26.3878 27.0033 26.8688C26.5573 27.3497 25.946 27.6444 25.2919 27.6936L25.0969 27.7001H19.8969C19.2409 27.7003 18.6091 27.4525 18.1282 27.0065C17.6472 26.5605 17.3526 25.9492 17.3034 25.2951L17.2969 25.1001V19.9001C17.2967 19.2441 17.5444 18.6123 17.9904 18.1313C18.4364 17.6504 19.0478 17.3558 19.7019 17.3066L19.8969 17.3001H25.0969ZM12.0969 19.9001H6.89688V25.1001H12.0969V19.9001ZM25.0969 19.9001H19.8969V25.1001H25.0969V19.9001ZM25.0969 4.30005C25.7528 4.29984 26.3846 4.54758 26.8656 4.9936C27.3466 5.43961 27.6412 6.05095 27.6904 6.70505L27.6969 6.90005V12.1001C27.6971 12.756 27.4494 13.3878 27.0033 13.8688C26.5573 14.3497 25.946 14.6444 25.2919 14.6936L25.0969 14.7001H19.8969C19.2409 14.7003 18.6091 14.4525 18.1282 14.0065C17.6472 13.5605 17.3526 12.9492 17.3034 12.2951L17.2969 12.1001V6.90005C17.2967 6.2441 17.5444 5.61231 17.9904 5.13134C18.4364 4.65036 19.0478 4.35575 19.7019 4.30655L19.8969 4.30005H25.0969ZM12.0969 4.30005C12.7528 4.29984 13.3846 4.54758 13.8656 4.9936C14.3466 5.43961 14.6412 6.05095 14.6904 6.70505L14.6969 6.90005V12.1001C14.6971 12.756 14.4494 13.3878 14.0033 13.8688C13.5573 14.3497 12.946 14.6444 12.2919 14.6936L12.0969 14.7001H6.89688C6.24093 14.7003 5.60914 14.4525 5.12816 14.0065C4.64719 13.5605 4.35257 12.9492 4.30338 12.2951L4.29688 12.1001V6.90005C4.29667 6.2441 4.5444 5.61231 4.99042 5.13134C5.43644 4.65036 6.04777 4.35575 6.70188 4.30655L6.89688 4.30005H12.0969ZM25.0969 6.90005H19.8969V12.1001H25.0969V6.90005ZM12.0969 6.90005H6.89688V12.1001H12.0969V6.90005Z"
                fill={display === "mosaic" ? "white" : "#1D1D1B"}
              />
            </g>
            <defs>
              <clipPath id="clip0_677_5609">
                <rect
                  x="0.398438"
                  y="0.400146"
                  width="31.2"
                  height="31.2"
                  rx="10"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </motion.button>
        <motion.button
          whileHover={{
            scale: 1.05,
          }}
          transition={{
            duration: 0.5,
            ease: "backInOut",
          }}
          className={
            display === "list"
              ? "bg-primary w-[52px] flex items-center justify-center"
              : "bg-white text-base-100 w-[52px] flex items-center justify-center"
          }
          onClick={onClick}
          name="list"
          aria-label="Affichage des pizzas en liste"
        >
          <svg
            style={{ pointerEvents: "none" }}
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.359375"
              y="0.359863"
              width="33.28"
              height="33.28"
              rx="10"
              fill={display === "mosaic" ? "white" : "primary"}
            />
            <path
              d="M10.7578 9.71973H29.4778M10.7578 16.9997H29.4778M10.7578 24.2797H29.4778"
              stroke={display === "mosaic" ? "#1D1D1B" : "white"}
              strokeWidth="1.65"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.55953 10.7599C6.13391 10.7599 6.59953 10.2943 6.59953 9.71993C6.59953 9.14556 6.13391 8.67993 5.55953 8.67993C4.98516 8.67993 4.51953 9.14556 4.51953 9.71993C4.51953 10.2943 4.98516 10.7599 5.55953 10.7599Z"
              stroke={display === "mosaic" ? "#1D1D1B" : "white"}
              strokeWidth="1.65"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.55953 18.04C6.13391 18.04 6.59953 17.5743 6.59953 17C6.59953 16.4256 6.13391 15.96 5.55953 15.96C4.98516 15.96 4.51953 16.4256 4.51953 17C4.51953 17.5743 4.98516 18.04 5.55953 18.04Z"
              stroke={display === "mosaic" ? "#1D1D1B" : "white"}
              strokeWidth="1.65"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.55953 25.3197C6.13391 25.3197 6.59953 24.8541 6.59953 24.2797C6.59953 23.7054 6.13391 23.2397 5.55953 23.2397C4.98516 23.2397 4.51953 23.7054 4.51953 24.2797C4.51953 24.8541 4.98516 25.3197 5.55953 25.3197Z"
              stroke={display === "mosaic" ? "#1D1D1B" : "white"}
              strokeWidth="1.65"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.button>
      </div>
    </>
  );
}
